module.exports = __webpack_public_path__ + "img/plus-simple.1e1f23d.svg";